import { useNavigate } from "react-router-dom";
import Button from "components/v2/Button/Button";
import { RequestSelectionType } from "./useGetRequestSelectionOptions";

interface RequestSelectionCardProps {
  requestSelection: RequestSelectionType;
  onHide: () => void;
}

export default function RequestSelectionCard({ requestSelection, onHide }: RequestSelectionCardProps) {
  const { title, description, buttonLabel, onClickPath, icon: Icon, badge } = requestSelection;
  const navigate = useNavigate();

  return (
    <div className="request-selection-card">
      <div className="request-selection-card--icon-container">{Icon && <Icon />}</div>

      <div className="request-selection-card--content-container">
        <div>
          <div className="d-flex align-items-center mb-sm">
            <div className="text-md font-semibold">{title}</div>
            {badge || null}
          </div>
          <div className="text-sm font-regular mb-xl">{description}</div>
        </div>
        <div className="d-flex justify-content-end">
          <Button
            label={buttonLabel}
            onClick={() => {
              navigate(onClickPath);
              onHide();
            }}
          />
        </div>
      </div>
    </div>
  );
}
